<template>
    <AnagraficaCrud titolo="Nodi (valori Uw del telaio)" endpoint="nodi" nuovo-label="Nuovo nodo" :colonne="colonne"
        :campi="campi" :filtri="filtri" :puo-scrivere="puoScrivere" :limite="5000"
        colonne-import="Tipologia, Sezione, Legno, VanoVetro, CodNodo, Descrizione, LNodo, LNodoEpoque, Soft (valore), Design, History, Epoque, CodiceProva, DataCalcolo (gg/mm/aaaa). Mantieni gli zeri iniziali dei codici nodo (01, 02...)." />
</template>

<script>
import AnagraficaCrud from "@/components/AnagraficaCrud.vue";

const TIPOLOGIE = ["SerramentiLegno", "AlzantiLegno", "AlzantiAlluminio", "SerramentiAlluminio"];
const LEGNI = ["SuperTenero", "Tenero", "Duro", "ExtraDuro"];

export default {
    name: "NodiPage",
    components: { AnagraficaCrud },

    data() {
        return {
            colonne: [
                { title: "Tipologia", key: "tipologia" },
                { title: "Sezione", key: "sezione" },
                { title: "Legno", key: "legno" },
                { title: "Vano vetro", key: "vanoVetro" },
                { title: "Cod.", key: "codNodo" },
                { title: "Descrizione", key: "descrizione" },
                { title: "L nodo", key: "lNodo" },
                { title: "Valore", key: "soft" },
            ],
            campi: [
                { key: "tipologia", label: "Tipologia", tipo: "select", items: TIPOLOGIE, required: true },
                { key: "legno", label: "Legno", tipo: "select", items: LEGNI, required: true },
                { key: "sezione", label: "Sezione (spessore anta)", tipo: "number", step: 1, required: true, default: 68 },
                { key: "vanoVetro", label: "Vano vetro", tipo: "number", step: 1, required: true, default: 32 },
                { key: "codNodo", label: "Codice nodo", tipo: "text", required: true, hint: "Con zeri iniziali: 01, 02..." },
                { key: "descrizione", label: "Descrizione", tipo: "text" },
                { key: "lNodo", label: "Larghezza nodo L (mm)", tipo: "number" },
                { key: "soft", label: "Valore Uw nodo (W/m²K)", tipo: "number" },
                { key: "lNodoEpoque", label: "L nodo Epoque", tipo: "number" },
                { key: "design", label: "Design", tipo: "number" },
                { key: "history", label: "History", tipo: "number" },
                { key: "epoque", label: "Epoque", tipo: "number" },
                { key: "codiceProva", label: "Codice prova", tipo: "text" },
                { key: "dataCalcolo", label: "Data calcolo", tipo: "date" },
            ],
            filtri: [
                { key: "tipologia", label: "Tipologia", items: TIPOLOGIE },
                { key: "legno", label: "Legno", items: LEGNI },
            ],
        };
    },

    computed: {
        puoScrivere() {
            const ruolo = this.$store.getters["user/getRole"];
            return ruolo === "Admin" || ruolo === "SuperAdmin";
        },
    },
};
</script>
